export default {"src":"/_next/static/media/semi-detached-icon-selected.a53bb617.svg","height":86,"width":124,"blurWidth":0,"blurHeight":0};